import React, { createContext, useContext } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Warsaw";

const TimeZoneContext = createContext(userTimeZone);

export const useTimeZone = () => useContext(TimeZoneContext);

export const TimeZoneProvider = ({children}) => {
    return <TimeZoneContext.Provider value={userTimeZone}>{children}</TimeZoneContext.Provider>;
};